import Tabs from './components/tabs'
import Modal from './components/modal'

$(document).ready(function () {

  if($('.billeterie').length > 0) {
    new Tabs();
  }

  if($('.modal-billetterie').length > 0) {
    var is_modal_show = sessionStorage.getItem('alreadyShow');
    const modal = new Modal('#billetterie-popup');
    if(is_modal_show != 'alredy shown'){
      setTimeout(function() {
        modal.open()
      }, 5000);
      sessionStorage.setItem('alreadyShow','alredy shown');
    }
  }

});
